/*
# Table with transactions subview (incl. amounts, debit/credit)
*/

var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['backbone', 'core', 'common/component/money-formatter', 'app-common/component/popover', 'component/tax-calculator', 'template/document-entry/transactions.htm', 'template/document-entry/tax-calculator.htm', 'template/document-entry/math-expression.htm', 'template/document-entry/keyboard-help.htm', 'common/lib/jquery.datatables'], function(Backbone, core, moneyFormatter, Popover, taxCalculator, transactionsTemplate, taxCalculatorTemplate, mathExpressionTemplate, keyboardHelpTemplate) {
  var TransactionsView;
  return TransactionsView = (function(_super) {

    __extends(TransactionsView, _super);

    function TransactionsView() {
      TransactionsView.__super__.constructor.apply(this, arguments);
    }

    TransactionsView.prototype.className = 'transactions-table-wrapper';

    TransactionsView.prototype.template = transactionsTemplate;

    TransactionsView.prototype.datatable = null;

    TransactionsView.prototype.calculatorPopover = null;

    TransactionsView.prototype.ledgerControl = null;

    TransactionsView.prototype.stashed = {
      transactions: [],
      currencyId: '',
      exchangeRate: ''
    };

    TransactionsView.prototype.foreignMode = false;

    TransactionsView.prototype.defaultLedgers = null;

    TransactionsView.prototype.numpadMinusKeycode = 109;

    TransactionsView.prototype.dashKeycode = 189;

    TransactionsView.prototype.numpadPlusKeycode = 107;

    TransactionsView.prototype.equalKeycode = 187;

    TransactionsView.prototype.enterKeycode = 13;

    TransactionsView.prototype.amountInputSelector = 'input.amount-value-input';

    TransactionsView.prototype.denyTransactionsRemoval = false;

    TransactionsView.prototype.events = {
      'click .add-transaction': 'addTransaction',
      'click .delete-transaction': 'deleteTransaction',
      'click .amount-toggle .toggle-text': function(e) {
        return this.debitCreditToggle($(e.currentTarget).parent());
      },
      'change input.amount-value-input': function(e) {
        return this.saveAmount($(e.currentTarget));
      },
      'dropdownPicked .ledger input[type=text]': 'saveLedger',
      'click #swap': 'swapTransactions',
      'click #calculate-taxes': 'showTaxCalculation',
      'hover #keyboard-shortcut-help': 'showKeyboardHelp'
    };

    TransactionsView.prototype.setupShortCuts = function() {
      var _this = this;
      $(document).on('keydown.transactions', this.amountInputSelector, 'space', function(e) {
        e.preventDefault();
        return _this.debitCreditToggle($(e.currentTarget).parent().parent());
      });
      $(document).on('keydown.transactions', null, 'q', function(e) {
        return _this.safeSetType('RECEIPT');
      });
      $(document).on('keydown.transactions', this.amountInputSelector, 'q', function(e) {
        e.preventDefault();
        return _this.safeSetType('RECEIPT');
      });
      $(document).on('keydown.transactions', null, 'w', function() {
        return _this.safeSetType('TRANSACTIONAL');
      });
      $(document).on('keydown.transactions', this.amountInputSelector, 'w', function(e) {
        e.preventDefault();
        return _this.safeSetType('TRANSACTIONAL');
      });
      $(document).on('keydown.transactions', null, 'e', function() {
        return _this.safeSetType('STATEMENT');
      });
      $(document).on('keydown.transactions', this.amountInputSelector, 'e', function(e) {
        e.preventDefault();
        return _this.safeSetType('STATEMENT');
      });
      $(document).on('keydown.transactions', null, 'r', function() {
        return _this.safeSetType('TAX');
      });
      $(document).on('keydown.transactions', this.amountInputSelector, 'r', function(e) {
        e.preventDefault();
        return _this.safeSetType('TAX');
      });
      $(document).on('keydown.transactions', null, 'f', function() {
        return _this.safeSetType('EXPORTS');
      });
      $(document).on('keydown.transactions', this.amountInputSelector, 'f', function(e) {
        e.preventDefault();
        return _this.safeSetType('EXPORTS');
      });
      $(document).on('keydown.transactions', null, 't', function() {
        return _this.safeSetType('OTHER');
      });
      $(document).on('keydown.transactions', this.amountInputSelector, 't', function(e) {
        e.preventDefault();
        return _this.safeSetType('OTHER');
      });
      $(document).on('keydown.transactions', null, 'a', function() {
        return _this.applyTaxesShortcut();
      });
      $(document).on('keydown.transactions', this.amountInputSelector, 'a', function(e) {
        e.preventDefault();
        _this.saveAmount($(e.currentTarget));
        return _this.applyTaxesShortcut();
      });
      $(document).on('keydown.transactions', this.amountInputSelector, function(e) {
        var input, popover, wrapper, _ref, _ref1, _ref2;
        input = $(e.currentTarget);
        if ((_ref = e.which) === _this.numpadPlusKeycode || _ref === _this.equalKeycode) {
          e.preventDefault();
          _this.saveAmount($(e.currentTarget));
          return _this.addTransaction(e);
        } else if (e.which === 219) {
          e.preventDefault();
          return $(input.closest('tr').get(0).previousSibling).find(_this.amountInputSelector).focus();
        } else if (e.which === 221) {
          e.preventDefault();
          return $(input.closest('tr').get(0).nextSibling).find(_this.amountInputSelector).focus();
        } else if ((_ref1 = e.which) === 111 || _ref1 === 191) {
          e.preventDefault();
          wrapper = input.parent();
          _this.calculatorPopover = popover = new Popover(wrapper, 'top');
          return popover.action(e, function() {
            var evaluateExpression;
            popover.build(_.template(mathExpressionTemplate));
            popover.show();
            $('.math-expression').focus();
            evaluateExpression = function() {
              var evaluatedAmount, expression, reg;
              expression = wrapper.find('.math-expression').val();
              try {
                reg = new RegExp(/^[-*+\/\.\(\)\d ]+$/);
                if (reg.test(expression)) {
                  evaluatedAmount = Math.abs(eval(expression));
                } else {
                  evaluatedAmount = void 0;
                }
              } catch (exception) {

              }
              if (isNaN(evaluatedAmount) || evaluatedAmount === Infinity) {
                return $('.math-expression').parent().addClass("popover-error");
              } else {
                input.val(moneyFormatter.formatNumber(evaluatedAmount));
                popover.hide();
                return input.focus();
              }
            };
            wrapper.find('.apply-action').on('click', function() {
              return evaluateExpression();
            });
            wrapper.find('.math-expression').on('keydown.transactions', null, function(ev) {
              if (ev.which === _this.enterKeycode || (ev.which === _this.equalKeycode && !ev.shiftKey)) {
                ev.preventDefault();
                return evaluateExpression();
              }
            });
            return wrapper.find('.cancel-action').on('click', function() {
              return popover.hide();
            });
          });
        } else if (e.which === _this.enterKeycode) {
          _this.saveAmount($(e.currentTarget));
          return $(e.currentTarget).blur();
        } else if (((_ref2 = e.which) === _this.numpadMinusKeycode || _ref2 === _this.dashKeycode) && !_this.denyTransactionsRemoval) {
          e.preventDefault();
          return _this.deleteTransaction(e);
        }
      });
      return $(document).on('focus', this.amountInputSelector, function(e) {
        if (_this.calculatorPopover !== null) {
          _this.calculatorPopover.hide();
          return _this.calculatorPopover = null;
        }
      });
    };

    TransactionsView.prototype.initialize = function() {
      var _this = this;
      this.model.on('change:documentType', this.updateType, this);
      this.model.on('transactions.recalculated', function() {
        return _this.updateForeignTransactions(true, _this);
      });
      this.model.on('change:dataEntries', this.reloadTable, this);
      this.model.on('request', this.clearStashedTransactions, this);
      this.defaultLedgers = core.getDefaultLedgers();
      this.addressModel = core.getModel('address');
      this.render();
      return this.updateForeignTransactions();
    };

    TransactionsView.prototype.render = function() {
      var options;
      options = _.extend({
        userCurrency: core.getDefaultCurrency()
      }, this.model.toJSON());
      this.$el.html(_.template(this.template, options));
      if (this.addressModel.get('countryId') === 1) {
        return this.$el.find('#calculate-taxes').show();
      }
    };

    TransactionsView.prototype.remove = function() {
      TransactionsView.__super__.remove.apply(this, arguments);
      $(document).off('keydown.transactions');
      this.stashed.transactions = [];
      this.stashed.currencyId = '';
      return this.stashed.exchangeRate = '';
    };

    TransactionsView.prototype.initTransactionsTable = function() {
      var _this = this;
      this.datatable = $('#transactions-table').dataTable({
        aoColumnDefs: [
          {
            aTargets: [0],
            mData: 'ledgerAccountId',
            sClass: 'ledger',
            sWidth: '61%',
            mRender: function(ledgerAccountId) {
              var ledgerControl;
              ledgerControl = _this.ledgerControl.clone();
              ledgerControl.find("option[value='" + ledgerAccountId + "']").attr('selected', 'selected');
              return $('<div/>').append(ledgerControl).html();
            }
          }, {
            aTargets: [1],
            mData: null,
            sClass: 'amount-control',
            sWidth: '32%',
            mRender: function(data, type, full) {
              var amount, foreignMode, html, typeText;
              typeText = full.entryType === 'DEBIT' ? 'DR' : 'CR';
              amount = moneyFormatter.formatNumber(Math.abs(full.amount));
              foreignMode = full.foreignAmount != null;
              html = $(("<div class='amount-toggle " + (full.entryType.toLowerCase()) + "'>") + ("<span class='amount-value'><input type='text' value='" + amount + "' class='amount-value-input'/></span>") + ("<span class='toggle-text'>" + typeText + "</span>") + "</div>");
              if (foreignMode) {
                html.find('.amount-value').addClass('disabled');
                html.find('.amount-value input').prop('disabled', true);
              }
              return html[0].outerHTML;
            }
          }, {
            aTargets: [2],
            mData: 'foreignAmount',
            sClass: 'foreign-amount',
            sWidth: '0',
            mRender: function(foreignAmount) {
              var amount;
              if (foreignAmount == null) {
                return '';
              }
              amount = moneyFormatter.formatNumber(Math.abs(foreignAmount));
              return "<span class='amount-value foreign'><input type='text' value='" + amount + "' /></span>";
            }
          }, {
            aTargets: [3],
            mData: null,
            sClass: 'actions',
            sWidth: '7%',
            mRender: function() {
              return '<span class="add-transaction transaction-action text-icon ss-plus"></span>' + '<span class="delete-transaction transaction-action text-icon ss-hyphen"></span>';
            }
          }
        ],
        fnRowCallback: function(row, data, index) {
          var existingRowsCount, tRow;
          tRow = $(row);
          existingRowsCount = $('.transaction-row').length;
          tRow.addClass('transaction-row validation-dataEntries');
          tRow.find('.ledger select').attr('id', "ledger-transaction-" + existingRowsCount).flexselect({
            sortAlphabetically: true
          });
          return row;
        },
        bInfo: false,
        bLengthChange: false,
        bFilter: false,
        bPaginate: false,
        bAutoWidth: false,
        bSort: false
      });
      this.datatable.find('tbody').addClass('validation-balance').attr('data-placement', 'in top');
      return this.refreshTransactions();
    };

    TransactionsView.prototype.refreshTransactions = function() {
      var dataEntry, _i, _len, _ref;
      if (this.foreignMode) {
        this.$el.find('th.ledger').css('width', '52%');
        this.$el.find('th.foreign-amount').css('width', '9%');
      } else {
        this.$el.find('th.ledger').css('width', '61%');
        this.$el.find('th.foreign-amount').css('width', '0');
      }
      _ref = this.model.get('dataEntries');
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        dataEntry = _ref[_i];
        this.datatable.fnAddData(dataEntry);
      }
      return this.handleDeleteAbility();
    };

    TransactionsView.prototype.reloadTable = function() {
      if (this.datatable == null) {
        return;
      }
      this.undelegateEvents();
      this.datatable.fnClearTable();
      this.refreshTransactions();
      return this.delegateEvents();
    };

    TransactionsView.prototype.handleDeleteAbility = function() {
      var _ref;
      if ((_ref = this.model.get('documentType')) !== 'RECEIPT' && _ref !== 'TRANSACTIONAL') {
        return;
      }
      if (this.model.get('dataEntries').length < 2) {
        return this.disableRowsRemoval();
      } else {
        return this.enableRowsRemoval();
      }
    };

    TransactionsView.prototype.findRow = function(element) {
      return $(element).closest('.transaction-row');
    };

    TransactionsView.prototype.findRowIndex = function(element) {
      return this.findRow(element).index();
    };

    TransactionsView.prototype.findRowByIndex = function(index) {
      return $($('.transaction-row')[index]);
    };

    TransactionsView.prototype.addTransaction = function(e) {
      var index, transaction;
      index = e != null ? this.findRowIndex(e.currentTarget) + 1 : null;
      transaction = {
        id: null,
        ledgerAccountId: this.defaultLedgers['misc.exp'].id,
        amount: 0,
        foreignAmount: this.foreignMode && this.model.get('documentType') !== 'RECEIPT' ? 0 : null,
        entryType: 'DEBIT'
      };
      this.model.addTransaction(transaction, index);
      this.reloadTable();
      return this.findRowByIndex(index).find('input').focus();
    };

    TransactionsView.prototype.deleteTransaction = function(e) {
      var index;
      index = e != null ? this.findRowIndex(e.currentTarget) : this.$el.find('.transaction-row:last').index();
      this.model.deleteTransaction(index);
      this.reloadTable();
      return this.findRowByIndex(index - 1).find('input').focus();
    };

    TransactionsView.prototype.countTransactions = function() {
      return this.model.get('dataEntries').length;
    };

    TransactionsView.prototype.clearTransactions = function() {
      this.model.clearTransactions();
      return this.datatable.fnClearTable();
    };

    TransactionsView.prototype.debitCreditToggle = function(toggle) {
      var dataEntries, dataEntry, de, index, sum, _i, _len;
      if (toggle.hasClass('debit')) {
        toggle.toggleClass('debit credit');
        toggle.children('.toggle-text').text('CR');
      } else if (toggle.hasClass('credit')) {
        toggle.toggleClass('credit debit');
        toggle.children('.toggle-text').text('DR');
      }
      this.saveAmount(toggle.find('input'));
      dataEntries = this.model.get('dataEntries');
      if (_.some(dataEntries, function(dataEntry) {
        return dataEntry.entryType === 'DEBIT';
      }) && _.some(dataEntries, function(dataEntry) {
        return dataEntry.entryType === 'CREDIT';
      })) {
        this.model.set('documentType', 'TRANSACTIONAL');
        index = this.findRowIndex(toggle);
        dataEntry = dataEntries[index];
        if (dataEntry.amount === 0) {
          sum = 0;
          for (_i = 0, _len = dataEntries.length; _i < _len; _i++) {
            de = dataEntries[_i];
            sum += de.amount;
          }
          dataEntry.amount = -sum.toFixed(2);
          dataEntries[index] = dataEntry;
          this.model.set('dataEntries', dataEntries);
          return this.reloadTable();
        }
      }
    };

    TransactionsView.prototype.showTable = function() {
      return this.$el.show();
    };

    TransactionsView.prototype.hideTable = function() {
      return this.$el.hide();
    };

    TransactionsView.prototype.enableRowsRemoval = function() {
      this.$el.find('.delete-transaction').show();
      return this.denyTransactionsRemoval = false;
    };

    TransactionsView.prototype.disableRowsRemoval = function() {
      this.$el.find('.delete-transaction').hide();
      return this.denyTransactionsRemoval = true;
    };

    TransactionsView.prototype.stashTransactions = function() {
      this.stashed.transactions = $.extend(true, [], this.model.get('dataEntries'));
      this.stashed.exchangeRate = this.model.get('currencyExchangeRate');
      this.stashed.currencyId = this.model.get('currencyId');
      this.model.set('currencyExchangeRate', null);
      return this.model.set('currencyId', core.getDefaultCurrency().id);
    };

    TransactionsView.prototype.unstashTransactions = function() {
      var transaction, _i, _len, _ref;
      if (this.stashed.transactions.length !== 0) {
        this.clearTransactions();
        _ref = this.stashed.transactions;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          transaction = _ref[_i];
          this.model.addTransaction(transaction);
          this.datatable.fnAddData(transaction);
        }
        this.stashed.transactions = [];
      }
      if (this.stashed.exchangeRate !== '') {
        this.model.set('currencyExchangeRate', this.stashed.exchangeRate);
        this.stashed.exchangeRate = '';
      }
      if (this.stashed.currencyId !== '') {
        this.model.set('currencyId', this.stashed.currencyId);
        return this.stashed.currencyId = '';
      }
    };

    TransactionsView.prototype.clearStashedTransactions = function() {
      this.stashed.transactions = [];
      this.stashed.exchangeRate = '';
      return this.stashed.currencyId = '';
    };

    TransactionsView.prototype.updateType = function() {
      switch (this.model.get('documentType')) {
        case 'TRANSACTIONAL':
        case 'RECEIPT':
        case 'UNKNOWN':
          this.showTable();
          this.unstashTransactions();
          this.handleDeleteAbility();
          if (this.countTransactions() === 0) {
            return this.addTransaction();
          }
          break;
        default:
          this.hideTable();
          if (this.stashed.transactions.length === 0) {
            this.stashTransactions();
          }
          return this.clearTransactions();
      }
    };

    TransactionsView.prototype.saveAmount = function(input) {
      var amount, errorCallback, foreign, index, type;
      index = this.findRowIndex(input);
      amount = Number(moneyFormatter.unformat(input.val()));
      type = this.findRow(input).find('.amount-toggle').hasClass('credit') ? 'credit' : 'debit';
      foreign = input.closest('.amount-value').hasClass('foreign');
      errorCallback = function(validValue) {
        return input.val(moneyFormatter.formatNumber(Math.abs(validValue)));
      };
      return this.model.updateTransactionAmount(index, amount, type, foreign, errorCallback);
    };

    TransactionsView.prototype.saveLedger = function(e) {
      var hiddenElementId, index, input, ledgerId;
      input = $(e.currentTarget);
      hiddenElementId = input.attr('id').replace('_flexselect', '');
      ledgerId = $('#' + hiddenElementId).val();
      index = this.findRowIndex(input);
      return this.model.updateTransactionLedger(index, ledgerId);
    };

    TransactionsView.prototype.updateLedger = function(index, ledger) {
      this.$el.find("#ledger-transaction-" + index).val(ledger.id);
      return this.$el.find("#ledger-transaction-" + index + "_flexselect").val(ledger.name).trigger('dropdownPicked');
    };

    TransactionsView.prototype.swapTransactions = function() {
      var _this = this;
      return this.$el.find('.transaction-row .amount-toggle').each(function(i, toggle) {
        return _this.debitCreditToggle($(toggle));
      });
    };

    TransactionsView.prototype.updateForeignTransactions = function(refreshTable) {
      var currentCurrency, currentCurrencyId, defaultCurrencyId;
      if (refreshTable == null) {
        refreshTable = false;
      }
      defaultCurrencyId = core.getDefaultCurrency().id;
      currentCurrencyId = this.model.get('currencyId');
      if (defaultCurrencyId !== currentCurrencyId) {
        this.foreignMode = true;
        currentCurrency = _.findWhere(core.getCollection('currencies').toJSON(), {
          id: currentCurrencyId
        });
        this.$el.find('.foreign-currency').html(currentCurrency.code);
      } else {
        this.foreignMode = false;
        this.$el.find('.foreign-currency').html('');
      }
      if (refreshTable) {
        return this.reloadTable();
      }
    };

    TransactionsView.prototype.showTaxCalculation = function(e) {
      var address, popover, regions, taxes, wrapper,
        _this = this;
      regions = _.reduce(core.getCollection('regions').toJSON(), function(regionList, region) {
        if (region.countryCode === 'CA' && region.name) {
          regionList.push({
            name: region.name,
            value: region.regionCode
          });
        }
        return regionList;
      }, []);
      address = this.addressModel.toJSON();
      taxes = taxCalculator.getTax(address.province);
      wrapper = $(e.currentTarget).parent();
      popover = new Popover(wrapper, 'bottom');
      return popover.action(e, function() {
        popover.build(_.template(taxCalculatorTemplate, {
          province: address.province,
          taxes: taxes,
          regions: regions
        }));
        popover.show();
        return _this.bindPopoverEvents(popover, wrapper, address.province, regions);
      });
    };

    TransactionsView.prototype.showKeyboardHelp = function(e) {
      var popover, wrapper,
        _this = this;
      wrapper = $(e.currentTarget);
      popover = new Popover(wrapper, 'right');
      return popover.action(e, function() {
        popover.build(_.template(keyboardHelpTemplate, {}));
        return popover.show();
      });
    };

    TransactionsView.prototype.bindPopoverEvents = function(popover, wrapper, province, regions) {
      var selectedProvince,
        _this = this;
      selectedProvince = province;
      wrapper.find('.apply-action').on('click', function() {
        var amountAsNumber, subtotal, taxes;
        taxes = $('.applicable-tax:checked').map(function(i, el) {
          return $(el).attr('name');
        });
        amountAsNumber = parseFloat($('#non-taxed-value').val());
        subtotal = !isNaN(amountAsNumber) ? amountAsNumber : void 0;
        _this.applyTaxes(selectedProvince, taxes.get(), subtotal);
        return popover.hide();
      });
      wrapper.find('.cancel-action').on('click', function() {
        return popover.hide();
      });
      return wrapper.find('.tax-region-select').on('change', function(e) {
        var taxes;
        selectedProvince = $(e.target).val();
        taxes = taxCalculator.getTax(selectedProvince);
        popover.hide();
        popover.build(_.template(taxCalculatorTemplate, {
          province: selectedProvince,
          taxes: taxes,
          regions: regions
        }));
        popover.show();
        return _this.bindPopoverEvents(popover, wrapper, selectedProvince, regions);
      });
    };

    TransactionsView.prototype.applyTaxes = function(province, taxes, subtotal) {
      if (taxCalculator.applySalesTax(this.model, province, taxes, subtotal)) {
        return this.reloadTable();
      } else {
        return this.renderError('dataEntries', 'Could not apply taxes', null, true, 'in top');
      }
    };

    TransactionsView.prototype.applyTaxesShortcut = function() {
      var address, taxObject, taxes;
      address = this.addressModel.toJSON();
      taxObject = taxCalculator.getTax(address.province);
      taxes = Object.keys(taxObject);
      return this.applyTaxes(address.province, taxes, 0);
    };

    return TransactionsView;

  })(Backbone.View);
});
